import { optimizedImages } from "@/data/optimized-images";
import { images, stats } from "@/data/resort";
import { OptimizedImage } from "./OptimizedImage";
import { Eyebrow, MaskReveal, Reveal } from "./reveal";
import { StatCounter } from "./StatCounter";

export function DestinationStory() {
  return (
    <section id="story" aria-labelledby="story-heading" className="bg-background py-16 md:py-24">
      <div className="shell">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="relative lg:col-span-6" y={40}>
            <OptimizedImage
              image={optimizedImages.storyMain}
              alt="Couple and their dog relaxing outside a motorhome under string lights at dusk"
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover"
            />
            <img
              src={images.storyDetail}
              alt="Emerald water of the American River flowing between granite boulders near Auburn"
              width={900}
              height={700}
              loading="lazy"
              decoding="async"
              className="absolute -bottom-10 -right-6 hidden w-[46%] border-[6px] border-background object-cover shadow-lift md:block lg:-right-16"
            />
          </Reveal>

          <div className="lg:col-span-6 lg:pl-10">
            <Reveal>
              <Eyebrow>Stay Here. Explore Everywhere.</Eyebrow>
            </Reveal>
            <h2 id="story-heading" className="display-lg mt-6 max-w-[22ch]">
              <MaskReveal>Adventure Starts</MaskReveal>
              <MaskReveal delay={0.08}>Just Outside</MaskReveal>
              <MaskReveal delay={0.16}>Your RV Door.</MaskReveal>
            </h2>
            <Reveal delay={0.15}>
              <div className="mt-8 space-y-5 text-base leading-relaxed text-muted-foreground md:text-[1.05rem]">
                <p>
                  Auburn RV Resort sits in the heart of the Sierra Foothills, where Northern
                  California's canyon country begins. Park once and the American River, Auburn State
                  Recreation Area and miles of hiking and biking trails are all within reach.
                </p>
                <p>
                  Spend a morning rafting, an afternoon wandering Gold Country storefronts and an
                  evening tasting wine grown in the foothills — then come back to a level,
                  full-hookup site and a quiet night under the pines.
                </p>
              </div>
            </Reveal>
          </div>
        </div>

        <dl className="mt-16 grid grid-cols-2 gap-y-8 border-t border-border pt-10 md:mt-20 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col-reverse pr-6">
              <dt className="eyebrow mt-4 text-muted-foreground">{stat.label}</dt>
              <dd className="font-display text-4xl leading-none tracking-tight text-primary md:text-5xl">
                {"value" in stat && typeof stat.value === "number" ? (
                  <StatCounter value={stat.value} suffix={stat.suffix} />
                ) : (
                  <span className="block text-xl leading-tight md:text-2xl">{stat.text}</span>
                )}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
